import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

import {
  firstColumnLeftPaddingVar,
  firstColumnWidthVar,
  zIndex,
} from '@new/__global/components/FastTapeChart/config/styles'

export const RowSummaryContainer = styled.div`
  position: sticky;
  left: 0;
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  align-items: center;
  padding-left: ${firstColumnLeftPaddingVar.get()};
  width: ${firstColumnWidthVar.get()};

  background: ${mainColors.white};
  border-width: 1px 0 2px 0;
  border-style: solid;
  border-color: ${mainColors.neutralMedium};

  z-index: ${zIndex.searchCell};
`
